import Vue from "vue"
import Vuex, { Store } from 'vuex'
import { createDirectStore } from "direct-vuex"
import favoriteList from "./FavoriteList"
import orderingList from "./OrderingList"
//import camera from "./cameraStore"
import auth from "./Auth"
import orderingListUser from "./OrderingListUserPermissions"
import orderingListRequestProduct from "./OrderingListRequestProduct";
import customerAgreement from "./CustomerAgreement";

Vue.use(Vuex);

const {
    store,
    rootActionContext,
    moduleActionContext,
    rootGetterContext,
    moduleGetterContext
} = createDirectStore({
    // … store implementation here …
    modules: {
        auth,
        favoriteList,
        orderingList,
        orderingListUser,
        orderingListRequestProduct,
        customerAgreement
    }
});

// Export the direct-store instead of the classic Vuex store.
export default store

// The following exports will be used to enable types in the
// implementation of actions and getters.
export {
    rootActionContext,
    moduleActionContext,
    rootGetterContext,
    moduleGetterContext
    }

// The following lines enable types in the injected store '$store'.
export type AppStore = typeof store
declare module "vuex" {
    interface Store<S> {
        direct: AppStore;
    }
}

